import { renderObjectIcon } from '../utils/icons';
import BusinessProcessBase, { TextLabelBehaviors } from './BusinessProcessBase';
import ShapeDiamond from './ShapeDiamond';

@TextLabelBehaviors
class ShapeBusinessProcessGateway extends BusinessProcessBase {
  static defaultWidth() {
    return 60;
  }

  static defaultHeight() {
    return 60;
  }

  static pathString() {
    return ShapeDiamond.pathString();
  }

  render(ctx: CanvasRenderingContext2D) {
    super.render(ctx);

    // Render the icon centred within the shape
    if (this.icon) {
      renderObjectIcon(
        ctx,
        this.icon,
        45 * this.fabricObject.scaleX,
        'center',
        this.fabricObject
      );
    }
  }
}

export default ShapeBusinessProcessGateway;
